<template>
   <div class="down_container">
        <!-- 轮播图 -->
        <el-carousel :interval="2000" height="550px" arrow="always">
          <el-carousel-item v-for="item in bannerList" :key="item">
              <img :src="item" alt=""  style="width: 100%">
          </el-carousel-item>
        </el-carousel>
       <ul class="down_box clearfloat">
          <li class="down_and" @mouseover="mouseOver(1)"  @mouseleave="mouseLeave(1)">
            <img  v-show="!andShow" :src="and" class="down_and_img" alt="">
              <div class="code_bg" v-show="andShow">
                  <img :src="qrcode" class="code_img" alt="">
                  <p class="down_title">扫码下载</p>
                  <p class="code_version">版本号:{{appVersion['latestAppVersion']}}</p>
              </div>
          </li>
          
          <li class="down_ios"  @mouseover="mouseOver(2)"  @mouseleave="mouseLeave(2)">
            <img  v-show="!iosShow" :src="ios" class="down_ios_img" alt="">
            <div class="code_bg" v-show="iosShow">
                <img :src="qrcode" class="code_img" alt="">
                <p class="down_title">扫码下载</p>
                <p class="code_version">版本号:{{appVersion['iosAppVersion']}}</p>
            </div>
          </li>
       </ul>
   </div>
</template>
<script>
import and  from '@/assets/images/Android.png';
import ios  from '@/assets/images/ios.png';
import qrcode  from '@/assets/images/qrcode.png';

export default {
    name: "downloadApp",
    props: {
    },
    data() {
        return {
           bannerList:[
            'https://wondpay-buck-01.oss-cn-shanghai.aliyuncs.com/banner/banner1.jpg',
            'https://wondpay-buck-01.oss-cn-shanghai.aliyuncs.com/banner/banner2.jpg',
            'https://wondpay-buck-01.oss-cn-shanghai.aliyuncs.com/banner/banner3.jpg',
            'https://wondpay-buck-01.oss-cn-shanghai.aliyuncs.com/banner/banner4.jpg',
           ],
           and,
           ios,
           qrcode,
           andShow:false,
           iosShow:false,
           appVersion:{},
        }
    },
    mounted() {
       //查询版本号 
       this.getAppVersion();
    },
    methods: {
       //监听变化 
       handleSelect(key) {
         this.$emit('upActiveIndex',key);
        // console.log(key, keyPath);
      },
      //鼠标移入事件 
      mouseOver(type){
        if(type == 1){
          if(this.andShow == false) this.andShow = true;
        }else{
          if(this.iosShow == false) this.iosShow = true;
        }

      },
      mouseLeave(type){
        if(type == 1){
         if(this.andShow == true) this.andShow = false;
        }else{
          if(this.iosShow == true) this.iosShow = false;
        }
      },
      getAppVersion() { //获取版本号 
            this.$api.post('/api/share/getAppVersion', {}, res => {
                if(res.status == 200){
                   this.appVersion = res.data; 
                }else{
                  this.$message.error(res.msg);
                }
            })
        }


    }
}
</script>
<style scoped lang='scss'>
    $down_width:200px;
    $down_height:200px;
    $box_width:$down_width+$down_height+100px;

    ul,li{ padding:0;margin:0;list-style:none}
    .clearfloat:after{
      display:block;
      clear:both;
      content:"";
      visibility:hidden;
      height:0
    }
    .clearfloat{
      zoom:1
    }
    .down_container{
        .down_box{
          width:$box_width;
          margin:0 auto;
          padding: 100px 0px;
           .down_and,.down_ios{
               float: left;
           }
           .down_and{
            margin-right: 100px;
           }
           .down_and_img,.down_ios_img{
              width:$down_width;
              height:$down_height;
           }
           .code_bg{
              background-image: url("../../../assets/images/code_bg.png");
              width:$down_width;
              height:$down_height;
              background-repeat:no-repeat;
              background-size: cover;
              position: relative;
              transition: all 2s linear 0s;
              .code_img{
                position: absolute;
                width: 110px;
                height: 110px;
                top:20px;
                left: 45px;
              }
              .down_title,.code_version{
                color:#fff;
                position: absolute;
                
              }
              .down_title{
                font-size: 18px;
                font-weight: bold;
                bottom: 17px;
                left:32%;
              }
              .code_version{
                font-size: 14px;
                bottom: 1px;
                left:27%;
              }
           }
        }
    }
    
</style>